import type { CSSProperties } from 'react';
import { css } from 'styled-components';

import { HEADINGS_VALUES } from 'hb-builder/components/UIComponents/shared/common/Root/utils/constants';
import {
  convertToPx,
  getAlignItems,
  getAlignSelf,
} from 'hb-builder/utils/attributes';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

interface GetWrapperTextStyleArgs {
  attributes: TextItemAttributes;
  canUpdateTextBackground?: boolean;
  networkFont?: string;
  // DefaultTheme is not exported
  theme: any;
}

export const getWrapperTextStyle = ({
  attributes,
  canUpdateTextBackground,
  networkFont,
  theme,
}: GetWrapperTextStyleArgs): CSSProperties => ({
  alignItems: getAlignItems(attributes.verticalAlign),
  // textFontFamily is not used in the Text component itself,
  // but it makes the Text component more flexible for its usage in other components.
  fontFamily: attributes.textFontFamily || networkFont,
  fontSize: attributes.textFontSize,
  letterSpacing: attributes.textLetterSpacing,
  lineHeight: convertToPx({
    lineHeight: attributes.textLineHeight,
    fontSize: attributes.textFontSize,
    theme,
  }),
  padding: attributes.containerPadding,
  textAlign: attributes.horizontalAlign,
  whiteSpace: 'break-spaces',
  wordBreak: 'break-word',
  ...(attributes.defaultTextColor
    ? {
        color: attributes.textColor,
      }
    : {}),
  ...(attributes.tied
    ? {
        ...(canUpdateTextBackground
          ? {
              alignSelf: getAlignSelf(attributes.horizontalAlign),
              backgroundColor: attributes.textBackgroundColor,
              width: 'auto',
            }
          : {}),
      }
    : {
        width: '100%',
      }),
});

const { h1, h2, h3 } = HEADINGS_VALUES.px.isDesktop;

export const headingStyles = () => css`
  h1 {
    font-size: ${h1.fontSize};
    font-weight: 600;
    line-height: ${h1.lineHeight};
  }

  h2 {
    font-size: ${h2.fontSize};
    font-weight: 600;
    line-height: ${h2.lineHeight};
  }

  h3 {
    font-size: ${h3.fontSize};
    font-weight: 600;
    line-height: ${h3.lineHeight};
  }
`;
